import { IUser } from '~/types/user-info-types'

import { UserField } from './user'

export enum Page {
  INITIAL,
  USER_DETAIL,
  USER_TYPE,
  USER_SKILL,
  REVIEW_ACCOUNT,
}

export enum SignUpScenario {
  CHECKOUT_FOR_OTHER = 'checkoutForOther',
  CHECKOUT_FOR_SELF = 'checkoutForSelf',
  COMPLETE_PROFILE = 'completeProfile',
  DEFAULT = 'default',
  MISSING_REQUIRED_FIELDS = 'missingRequiredFields',
  SUBSCRIPTION = 'subscription',
  BOOKING = 'booking',
}

export interface RegisterFields {
  [UserField.AVATAR_PNG]?: IUser[UserField.AVATAR_PNG]
  [UserField.AVATAR_GLB]?: IUser[UserField.AVATAR_GLB]
  [UserField.BIRTH_YEAR]?: IUser[UserField.BIRTH_YEAR]
  [UserField.COUNTRY]?: IUser[UserField.COUNTRY]
  [UserField.COUNTRY_CALLING_CODE]: string
  [UserField.COUNTRY_CODE]: string
  [UserField.EMAIL]?: IUser[UserField.EMAIL]
  [UserField.FACEBOOK_EMAIL]?: IUser[UserField.FACEBOOK_EMAIL]
  [UserField.AUTH_EMAIL]?: IUser[UserField.AUTH_EMAIL]
  [UserField.FULL_NAME]?: IUser[UserField.FULL_NAME]
  [UserField.GRADE_LEVEL_ID]?: IUser[UserField.GRADE_LEVEL_ID]
  [UserField.NICKNAME]?: IUser[UserField.NICKNAME]
  [UserField.PASSWORD]?: string
  [UserField.PASSWORD_CONFIRM]?: string
  [UserField.PHONE]?: IUser[UserField.PHONE]
  [UserField.SKILL]?: IUser[UserField.SKILL]
  [UserField.TIMEZONE]?: IUser[UserField.TIMEZONE]
  [UserField.TYPE]?: IUser[UserField.TYPE]
  [UserField.WANTS_NEWSLETTER]?: IUser[UserField.WANTS_NEWSLETTER]
  [UserField.YEARS_IN_SCHOOL]?: IUser[UserField.YEARS_IN_SCHOOL]
  captchaAnswer?: string
}

export type RegisterErrors = {
  [T in keyof RegisterFields as string]?: string
}
